import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Button } from 'semantic-ui-react';
import moment from 'moment';

import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { PagingFilterTypeEnum } from 'Common/Constants/Enumeration/PagingFilterTypeEnum';

import { getAccountSetup, saveStudentFilters } from '../state/actions';

class StudentGridContainer extends Component {
  constructor(props) {
    super(props);
    this.timer = null;
  }

  state = {
    filtered: [],
    sorted: [],
    lastKeyAt: null,
    isFiterChange: false,
  };

  componentDidMount() {
    this.props.onRef(this);
  }
  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  isTimeToFetch() {
    let isDelay = moment().isAfter(moment(this.state.lastKeyAt));
    if (this.state.isFiterChange) {
      isDelay = moment().isAfter(moment(this.state.lastKeyAt).add(1, 's'));
    }
    if (isDelay) {
      this.timer = null;
      this.setState({ lastKeyAt: null, isFiterChange: false });
      this.props.getAccountSetup(this.props.studentFilter);
    }
  }

  fetchData = (state, instance) => {
    clearInterval(this.timer);
    if (this.props.siteChange) {
      this.timer = null;
      let filters = [];
      let sorts = [];
      let timeOut = this.state.isFiterChange ? 200 : 0;
      if (state.filtered && state.filtered.length > 0) {
        state.filtered.map((filterValue, i) => {
          filters.push({
            FilterName: filterValue.id,
            FilterValue: filterValue.value,
            FilterType: PagingFilterTypeEnum.MatchFromStart,
          });
          return null;
        });
      }
      if (state.sorted && state.sorted.length > 0) {
        state.sorted.map((sortValue, i) => {
          sorts.push({
            SortName: sortValue.id,
            SortDirection: sortValue.desc ? 'desc' : 'asc',
          });
          return null;
        });
      }

      let page = {
        ...this.props.studentFilter,
        PageNumber: state.page + 1,
        PageSize: state.pageSize,
        Filter: filters,
        SortColumn: sorts,
      };
      this.props.saveStudentFilters(page);
      this.setState(
        {
          lastKeyAt: moment(),
          loading: true,
        },
        () => {
          this.timer = setInterval(() => {
            this.isTimeToFetch();
          }, timeOut);
        }
      );
    }
  };

  clearFilters = () => {
    this.setState({
      filtered: [],
      sorted: [],
    });
    let clearObject = {
      Filter: [],
      SortColumn: [],
    };
    this.props.getAccountSetup(clearObject);
  };

  render() {
    const {
      gridLoading,
      TotalPages,
      menuOptions,
      data,
      siteChange,
    } = this.props;
    const { sorted, filtered } = this.state;
    return (
      <Fragment>
        <Button
          floated="right"
          onClick={this.clearFilters}
          disabled={
            this.state.filtered.length === 0 && this.state.sorted.length === 0
          }
          style={{ marginBottom: 20 }}
        >
          Clear Filters
        </Button>
        <ReactTable
          manual
          className={'grid--fixed-row-height'}
          data={data}
          loading={gridLoading}
          onFetchData={this.fetchData}
          multiSort={false}
          minRows={data.length === 0 ? 20 : data.length}
          filtered={filtered}
          sorted={sorted}
          filterable={siteChange ? true : false}
          resizable={true}
          onSortedChange={sorted => this.setState({ sorted })}
          onFilteredChange={filtered =>
            this.setState({ filtered: filtered, isFiterChange: true })
          }
          pages={TotalPages}
          getTrProps={(state, rowInfo, column) => {
            return {
              style: {
                color:
                  rowInfo &&
                  rowInfo.original &&
                  rowInfo.original.StatusCurrent === '5'
                    ? 'red'
                    : '',
              },
            };
          }}
          columns={[
            {
              Header: 'Student #',
              accessor: 'Id',
            },
            {
              Header: 'Serving #',
              accessor: 'ServingNum',
            },
            {
              Header: 'Last Name',
              accessor: 'LastName',
            },
            {
              Header: 'First Name',
              accessor: 'FirstName',
            },
            {
              Header: 'DOB',
              accessor: 'BirthDate',
            },
            {
              Header: 'Teacher',
              accessor: 'Teacher',
            },
            {
              Header: 'Grade',
              accessor: 'GradeId',
              width: 60,
            },
            {
              Header: 'Status',
              accessor: 'StatusCurrent',
              width: 50,
            },
            {
              Header: 'Site Id',
              accessor: 'SiteId',
            },
            {
              filterable: false,
              resizable: false,
              width: 50,
              sortable: false,
              Cell: gridProps => {
                return GridContextMenu({ gridProps, options: menuOptions });
              },
            },
          ]}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = ({ AccountSetupState }) => {
  return {
    gridLoading: AccountSetupState.gridLoading,
    studentFilter: AccountSetupState.studentFilter,
  };
};

export const StudentGrid = connect(mapStateToProps, {
  getAccountSetup,
  saveStudentFilters,
})(StudentGridContainer);



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/StudentGrid.js